import {View} from 'MWC';
import tpl from '../templates/interactive.jsx';
import BaseNewCardView from './../../../../pages/Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    shouldFetchData() {
        return false;
    }

    template = tpl;
}
